import service from '@/middleware'

const enterpriseApi = {
    /**
     * Para obtener las empresas (que tengan una relación con el usuario) para los selectores de ABMs
     */
    async getAllForSelector () {
        const result = await service.http.get(`/api/enterprise/all-for-selector`)
        return result
    },

    /**
     * Para obtener las empresas (que tengan una relación con el usuario) para el selector de empresas
     * del ABM de usuarios
     */
    async getAllForSelectorUserABM (enterpriseIds) {
        const result = await service.http.post('/api/enterprise/selector-user-abm', enterpriseIds)
        return result
    },

    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers si hay que devolver o no el arreglo con los headers de la tabla
     */
    async findAll(pageSize, pageNumber, headers = false) {
        const url = pageSize != null && pageNumber != null
            ? `/api/enterprise/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
            : `/api/enterprise/all?headers=${headers}`
        const response = await service.http.get(url)
        return response
    },

    /**
     * Devuelve los datos de una empresa para su actualización
     * @param {*} id 
     */
    async findOne(id) {
        const response = await service.http.get(
            `/api/enterprise/one-by-id/${id}`)
        return response
    },

    /**
     * Total de empresas de la collection (para el paginador)
     */
    async getTotal () {
        const response = await service.http.get(`/api/enterprise/total`)
        return response
    },

    /**
     * Para crear una nueva empresa
     * @param {*} enterprise
     */
    async create (enterprise) {
        const result = await service.http.post(`/api/enterprise/create`, enterprise)
        return result
    },

    /**
     * Para actualizar una empresa
     * @param {*} enterprise
     */
    async update (enterprise) {
        const result = await service.http.put(`/api/enterprise/update`, enterprise)
        return result
    },

    /**
     * Para eliminar una empresa
     * @param {*} id
     */
    async deleteOne (id) {
        const result = await service.http.delete(`/api/enterprise/${id}`)
        return result
    },

    /**
     * Para elminación múltiple
     * @param {*} ids
     */
    async deleteMany (ids) {
        const result = await service.http.put(`/api/enterprise/multiple-delete`, ids)
        return result
    },

    /**
     * Para validar el nombre de la empresa
     * @param {*} name
     */
    async validateName(name) {
        const result = await service.http.get(`/api/enterprise/validate-name/${name}`)
        return result
    },

    /**
     * Obtener un arreglo de privilegios para la configuración de los headers dinámicos en el ABM de Empresa
     */
    async getRoutesPrivileges () {
        const response = await service.http.get(`/api/enterprise/route-privileges`)
        return response
    },

    /**
     * Crear una nueva empresa a partir de clonar otra 
     */
    async clone({ cloneId, name }) {
        const response = await service.http.post(`/api/enterprise/clone`, { cloneId, name })
        return response
    },

    async getUsersWithoutEnterprise () {
        const result = await service.http.get(`/api/user/usersWithoutEnterprise`)
        return result
    },

    async getUsersByEnterpriseId (enterpriseId) {
        const result = await service.http.get(`/api/user/usersByEnterprise/${enterpriseId}`)
        return result
    },

    /**
     * Guarda la imagen de background al crear o actualizar un enterprise
     */
    async saveImage (enterpriseName, enterpriseImage) {
        const response = await service.http.post(`/api/enterprise/save-image`, { enterpriseName, enterpriseImage})
        return response
    }


}

export default enterpriseApi
